class DataBrowserService {
  constructor(config, httpDim) {
    this.config = config;
    this.httpDim = httpDim;
    this.name = 'dataBrowserService';
  }

  fetchUsersByCustomer(fetchCriteria) {
    let offset = fetchCriteria.offset;
    let limit = fetchCriteria.limit;
    let searchValue = fetchCriteria.searchValue;
    let config = this.config;
    let url = `${this.config.apiRoot}/users?offset=${offset}&limit=${limit}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchPersonAssignmentsAndAffiliations(fetchCriteria) {
    let offset = fetchCriteria.offset;
    let limit = fetchCriteria.limit;
    let personId = fetchCriteria.personId;
    let role = fetchCriteria.role;
    let config = this.config;
    let url = `${this.config.apiRoot}/users/${personId}/assignmentsAndAffiliations?offset=${offset}&limit=${limit}&role=${role}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }
}

DataBrowserService.$inject = ['config', 'httpDim'];

export default DataBrowserService;


// WEBPACK FOOTER //
// ./app/common/dataBrowserService/dataBrowserService.service.js